export const SELECT_SIGNATURE = 'Select Signature';
export const DRAW_INITIALS = 'Draw Initials';
export const DRAW_SIGNATURE = 'Draw Signature';
export const UPLOADED_SIGNATURE = 'View Uploaded Signature'
export const SELECT_INITIALS = 'Select Initials';
export const CONFIRM_SIGNATURE = 'Confirm Signatures';
